import request from '@/utils/request'

/**
 * @description: 用户列表
 * @param {*} params
 * @return {*}
 */
const userList = (params) => {
  return request({
    url: '/admin/user/list',
    method: 'get',
    params
  })
}

/**
 * @description: 新增用户
 * @param {*} params
 * @return {*}
 */
const userAdd = (params) => {
  return request({
    url: '/admin/user/add',
    method: 'post',
    data: params
  })
}

/**
 * @description: 编辑用户
 * @param {*} params
 * @return {*}
 */
const userEdit = (params) => {
  return request({
    url: '/admin/user/edit',
    method: 'post',
    data: params
  })
}

/**
 * @description: 删除用户
 * @param {*} params
 * @return {*}
 */
const userDelete = (params) => {
  return request({
    url: '/admin/user/delete',
    method: 'post',
    params
  })
}

/**
 * @description: 管理员列表
 * @param {*} params
 * @return {*}
 */
const adminList = (params) => {
  return request({
    url: '/admin/list',
    method: 'get',
    params
  })
}

/**
 * @description: 新增管理员
 * @param {*} params
 * @return {*}
 */
const adminAdd = (params) => {
  return request({
    url: '/admin/add',
    method: 'post',
    data: params
  })
}

/**
 * @description: 编辑管理员
 * @param {*} params
 * @return {*}
 */
const adminEdit = (params) => {
  return request({
    url: '/admin/edit',
    method: 'post',
    data: params
  })
}

/**
 * @description: 删除管理员
 * @param {*} params
 * @return {*}
 */
const adminDelete = (params) => {
  return request({
    url: '/admin/delete',
    method: 'post',
    params
  })
}

/**
 * @description: 助教列表
 * @param {*} params
 * @return {*}
 */
const assistantList = (params) => {
  return request({
    url: '/admin/assistant/list',
    method: 'get',
    params
  })
}

/**
 * @description: 新增助教
 * @param {*} params
 * @return {*}
 */
const assistantAdd = (params) => {
  return request({
    url: '/admin/assistant/add',
    method: 'post',
    data: params
  })
}

/**
 * @description: 编辑助教
 * @param {*} params
 * @return {*}
 */
const assistantEdit = (params) => {
  return request({
    url: '/admin/assistant/edit',
    method: 'post',
    data: params
  })
}

/**
 * @description: 删除助教
 * @param {*} params
 * @return {*}
 */
const assistantDelete = (params) => {
  return request({
    url: '/admin/assistant/delete',
    method: 'post',
    params
  })
}

/**
 * @description: 获取角色
 * @param {*} params
 * @return {*}
 */
const roleList = () => {
  return request({
    url: '/admin/role/list',
    method: 'get'
  })
}

export default {
  userList,
  userAdd,
  userEdit,
  userDelete,
  adminList,
  adminAdd,
  adminEdit,
  adminDelete,
  assistantList,
  assistantAdd,
  assistantEdit,
  assistantDelete,
  roleList
}
